import React from 'react';
import { Button } from 'antd';
import {
    InstagramOutlined,
    YoutubeOutlined,
} from '@ant-design/icons';


const SNSBox = () => {
    const onOpenInstagram = () => {
        window.open("https://www.instagram.com/dev09_studio/", "_blank");
    }

    const onOpenYoutube = () => {
        window.open("https://www.youtube.com/channel/UC5UlD9LLbtpoUsrWrYMGz0g", "_blank");
    }

    return (
        <div className={'sns-box'}>
            <Button onClick={onOpenInstagram} size={'large'} type={'text'} icon={<InstagramOutlined className={'sns-box__icon'} style={{fontSize:28}}/>} />
            <Button onClick={onOpenYoutube} size={'large'} type={'text'} icon={<YoutubeOutlined className={'sns-box__icon'} style={{fontSize:28}}/>} />
        </div>
    );
};


export default SNSBox;